import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Lista } from '../models/lista.model';
import { Combobox } from 'pmv-common';

@Injectable()
export class ListaService {

  constructor(private httpClient: HttpClient) { }

  GetByParam(id: number): Observable<Lista[]> {
    return this.httpClient.get<Lista[]>(`/Interop/Listas/${id}`);
  }

  GetPaisesHeSocial(): Observable<Lista[]>{
    return this.httpClient.get<Lista[]>(`/Interop/Listas/paises/esocial`);
  }

  GetEntidadesExternas(): Observable<Lista[]>{
    return this.httpClient.get<Lista[]>(`/Interop/Listas/EntidadesExternas`);
  }

  PostByParam(ids: number[]): Observable<Lista[]> {
    return this.httpClient.post<Lista[]>(`/Interop/Listas`,ids);
  }

  GetByParamCombobox(id: number): Observable<Combobox[]> {
    return this.httpClient.get<Combobox[]>(`/Interop/Listas/Combobox/${id}`);
  }

  GetByParamStatusFilterCombobox(id: number): Observable<Combobox[]> {
    return this.httpClient.get<Combobox[]>(`/Interop/Listas/StatusFilterCombobox/${id}`);
  }

  
  GetSecretariasByText(texto?: string): Observable<string[]> {
    let url = `/Interop/GetSecretariasByText`;
    if (texto) {
      url += `?texto=${texto.replace('/', '|')}`;
    }
    return this.httpClient.get<string[]>(url);
  }

  GetVeiculoPublicacaoByText(texto?: string): Observable<string[]> {
    let url = `/Interop/GetVeiculoPublicacaoByText`;
    if (texto) {
      url += `?texto=${texto.replace('/', '|')}`;
    }
    return this.httpClient.get<string[]>(url);
  }
  
  
}



// WEBPACK FOOTER //
// ./src/app/services/lista.service.ts